import templateDefaults from '../templateDefaults';

const TGB_ASSETS_URL = process.env.TGB_ASSETS_CDN_URL;

export default {
  previewImage: '/img/sports/fullscreen.png',
  title: 'Fullscreen',
  templateData() {
    return {
      version: 'v1.1',
      title: 'Sports Fullscreen',
      ...templateDefaults,
      elements: [
        {
          version: 'v1',
          type: 'image',
          name: 'Flare',
          editable: false,
          locked: false,
          aspectLock: true,
          mask: false,
          maskShape: 'oval',
          imageUrl: `${TGB_ASSETS_URL}/placeholders/flare-2.png`,
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          fillType: 'stretch',
          border: false,
          borderWidth: 2,
          borderColor: '#000000',
          boxShadow: false,
          boxShadowX: 1,
          boxShadowY: 2,
          boxShadowBlur: 4,
          boxShadowSpread: 0,
          boxShadowColor: '#000000',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0,
          blur: false,
          blurSize: 10,
          styles: {
            top: 519,
            left: 239,
            width: 233,
            height: 427,
            opacity: 1,
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Text',
          locked: false,
          text: '<p class="ql-align-center">2018</p><p class="ql-align-center">REG</p>',
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          ellipsis: true,
          whiteSpace: 'normal',
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 328,
            left: 979,
            width: 130,
            height: 98,
            opacity: 1,
            color: 'rgb(176, 224, 254)',
            fontFamily: 'Roboto Condensed',
            textTransform: 'none',
            textDecoration: 'none',
            fontSize: 36,
            fontWeight: 'normal',
            fontStyle: 'normal',
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Text',
          locked: false,
          text: '<p class="ql-align-center">2017</p><p class="ql-align-center">REG</p>',
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          ellipsis: true,
          whiteSpace: 'normal',
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 328,
            left: 849,
            width: 130,
            height: 98,
            opacity: 1,
            color: 'rgb(176, 224, 254)',
            fontFamily: 'Roboto Condensed',
            textTransform: 'none',
            textDecoration: 'none',
            fontSize: 36,
            fontWeight: 'normal',
            fontStyle: 'normal',
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Text',
          locked: false,
          text: '<p class="ql-align-center">2016</p><p class="ql-align-center">REG</p>',
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          ellipsis: true,
          whiteSpace: 'normal',
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 328,
            left: 719,
            width: 130,
            height: 98,
            opacity: 1,
            color: 'rgb(176, 224, 254)',
            fontFamily: 'Roboto Condensed',
            textTransform: 'none',
            textDecoration: 'none',
            fontSize: 36,
            fontWeight: 'normal',
            fontStyle: 'normal',
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Text',
          locked: false,
          text: '<p class="ql-align-center"><strong>15-8</strong></p><p class="ql-align-center"><strong>3.31</strong></p><p class="ql-align-center"><strong>.625</strong></p><p class="ql-align-center"><strong>50.1%</strong></p><p class="ql-align-center"><strong>5.4”</strong></p><p class="ql-align-center"><strong>8.3%</strong></p><p class="ql-align-center"><strong>17.8%</strong></p><p class="ql-align-center"><strong>10.4%</strong></p>',
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          ellipsis: true,
          whiteSpace: 'normal',
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 430,
            left: 980,
            width: 126,
            height: 382,
            opacity: 1,
            color: 'rgb(255, 255, 255)',
            fontFamily: 'Roboto Condensed',
            textTransform: 'none',
            textDecoration: 'none',
            fontSize: 36,
            fontWeight: 'normal',
            fontStyle: 'normal',
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Text',
          locked: false,
          text: '<p class="ql-align-center"><strong>15-8</strong></p><p class="ql-align-center"><strong>3.31</strong></p><p class="ql-align-center"><strong>.625</strong></p><p class="ql-align-center"><strong>50.1%</strong></p><p class="ql-align-center"><strong>5.4”</strong></p><p class="ql-align-center"><strong>8.3%</strong></p><p class="ql-align-center"><strong>17.8%</strong></p><p class="ql-align-center"><strong>10.4%</strong></p>',
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          ellipsis: true,
          whiteSpace: 'normal',
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 430,
            left: 856,
            width: 126,
            height: 382,
            opacity: 1,
            color: 'rgb(255, 255, 255)',
            fontFamily: 'Roboto Condensed',
            textTransform: 'none',
            textDecoration: 'none',
            fontSize: 36,
            fontWeight: 'normal',
            fontStyle: 'normal',
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Text',
          locked: false,
          text: '<p class="ql-align-center"><strong>15-8</strong></p><p class="ql-align-center"><strong>3.31</strong></p><p class="ql-align-center"><strong>.625</strong></p><p class="ql-align-center"><strong>50.1%</strong></p><p class="ql-align-center"><strong>5.4”</strong></p><p class="ql-align-center"><strong>8.3%</strong></p><p class="ql-align-center"><strong>17.8%</strong></p><p class="ql-align-center"><strong>10.4%</strong></p>',
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          ellipsis: true,
          whiteSpace: 'normal',
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 429,
            left: 721,
            width: 126,
            height: 382,
            opacity: 1,
            color: 'rgb(255, 255, 255)',
            fontFamily: 'Roboto Condensed',
            textTransform: 'none',
            textDecoration: 'none',
            fontSize: 36,
            fontWeight: 'normal',
            fontStyle: 'normal',
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Text',
          locked: false,
          text: '<p>W-L</p><p>Era</p><p>Opp. OPS</p><p>Pitches in zone</p><p>Curve vertical break</p><p>1st-pitch curve use</p><p>1st-pitch swings</p><p>Walk rate</p>',
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          ellipsis: true,
          whiteSpace: 'normal',
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 428,
            left: 389,
            width: 304,
            height: 366,
            opacity: 1,
            color: 'rgb(176, 224, 254)',
            fontFamily: 'Roboto Condensed',
            textTransform: 'none',
            textDecoration: 'none',
            fontSize: 36,
            fontWeight: 'normal',
            fontStyle: 'normal',
          },
        },
        {
          version: 'v1',
          type: 'image',
          name: 'player-headshot.png',
          editable: true,
          locked: false,
          aspectLock: true,
          mask: false,
          maskShape: 'oval',
          imageUrl: `${TGB_ASSETS_URL}/placeholders/player-headshot.png`,
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          fillType: 'stretch',
          border: false,
          borderWidth: 2,
          borderColor: '#000000',
          boxShadow: false,
          boxShadowX: 1,
          boxShadowY: 2,
          boxShadowBlur: 4,
          boxShadowSpread: 0,
          boxShadowColor: '#000000',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0,
          blur: false,
          blurSize: 10,
          styles: {
            top: 399,
            left: 1157,
            width: 389,
            height: 427,
            opacity: 1,
          },
        },
        {
          version: 'v1',
          type: 'rectangle',
          name: 'Blue Box',
          locked: false,
          aspectLock: false,
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          border: true,
          borderWidth: 8,
          borderColor: 'rgb(255, 255, 255)',
          boxShadow: true,
          boxShadowX: -4,
          boxShadowY: 4,
          boxShadowBlur: 18,
          boxShadowSpread: 1,
          boxShadowColor: 'rgba(0, 0, 0, 0.52)',
          fillStyle: 'solid',
          backgroundColor: 'rgba(0, 90, 45, 0.9)',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          backgroundImage: false,
          backgroundImageUrl: '',
          borderTopLeftRadius: 15,
          borderTopRightRadius: 15,
          borderBottomRightRadius: 15,
          borderBottomLeftRadius: 15,
          blur: false,
          blurSize: 10,
          skewX: 0,
          skewY: 0,
          rotate: 0,
          styles: {
            top: 310,
            left: 1150,
            width: 405,
            height: 525,
            opacity: 1,
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Sub-headline',
          locked: false,
          text: '<p>POSTSEASON WRAP-UP</p>',
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          ellipsis: true,
          whiteSpace: 'normal',
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 250,
            left: 405,
            width: 612,
            height: 28,
            opacity: 1,
            color: 'rgb(255, 255, 255)',
            fontFamily: 'Roboto Condensed',
            textTransform: 'uppercase',
            textDecoration: 'none',
            fontSize: 24,
            fontWeight: 'normal',
            fontStyle: 'normal',
          },
        },
        {
          version: 'v1',
          type: 'image',
          name: 'Team Logo',
          editable: true,
          locked: false,
          aspectLock: true,
          mask: false,
          maskShape: 'oval',
          imageUrl: `${TGB_ASSETS_URL}/logos/tagboard-hash-white.png`,
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          fillType: 'stretch',
          border: false,
          borderWidth: 2,
          borderColor: '#000000',
          boxShadow: false,
          boxShadowX: 1,
          boxShadowY: 2,
          boxShadowBlur: 4,
          boxShadowSpread: 0,
          boxShadowColor: '#000000',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0,
          blur: false,
          blurSize: 10,
          styles: {
            top: 206,
            left: 1055,
            width: 79,
            height: 72,
            opacity: 1,
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Player Position',
          locked: false,
          text: '<p>SP</p>',
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          ellipsis: true,
          whiteSpace: 'normal',
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 199,
            left: 875,
            width: 64,
            height: 45,
            opacity: 1,
            color: 'rgb(255, 255, 255)',
            fontFamily: 'Roboto Condensed',
            textTransform: 'uppercase',
            textDecoration: 'none',
            fontSize: 40,
            fontWeight: 'normal',
            fontStyle: 'normal',
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Player Number',
          locked: false,
          text: '<p class="ql-align-center">7</p>',
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          ellipsis: true,
          whiteSpace: 'normal',
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 199,
            left: 785,
            width: 90,
            height: 45,
            opacity: 1,
            color: 'rgb(255, 255, 255)',
            fontFamily: 'Roboto Condensed',
            textTransform: 'uppercase',
            textDecoration: 'none',
            fontSize: 40,
            fontWeight: 'normal',
            fontStyle: 'normal',
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Player Name',
          locked: false,
          text: '<p><strong>PLAYER NAME</strong></p>',
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          ellipsis: true,
          whiteSpace: 'normal',
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 200,
            left: 405,
            width: 374,
            height: 43,
            opacity: 1,
            color: 'rgb(255, 255, 255)',
            fontFamily: 'Roboto Condensed',
            textTransform: 'uppercase',
            textDecoration: 'none',
            fontSize: 40,
            fontWeight: 'normal',
            fontStyle: 'normal',
          },
        },
        {
          version: 'v1',
          type: 'rectangle',
          name: 'Highlight',
          locked: false,
          aspectLock: false,
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          border: false,
          borderWidth: 8,
          borderColor: 'rgb(255, 255, 255)',
          boxShadow: false,
          boxShadowX: -4,
          boxShadowY: 4,
          boxShadowBlur: 18,
          boxShadowSpread: 1,
          boxShadowColor: 'rgba(0, 0, 0, 0.52)',
          fillStyle: 'gradient',
          backgroundColor: 'rgba(255, 255, 255, 0.19)',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: 'rgb(255, 255, 255)',
          gradientColorTwo: 'rgba(255, 255, 255, 0.28)',
          backgroundImage: false,
          backgroundImageUrl: '',
          borderTopLeftRadius: 15,
          borderTopRightRadius: 15,
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0,
          blur: false,
          blurSize: 10,
          skewX: -25,
          skewY: 0,
          rotate: 0,
          styles: {
            top: 183,
            left: 389,
            width: 790,
            height: 66,
            opacity: '0.25',
          },
        },
        {
          version: 'v1',
          type: 'rectangle',
          name: 'Black Bar',
          locked: false,
          aspectLock: false,
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          border: true,
          borderWidth: 8,
          borderColor: 'rgb(255, 255, 255)',
          boxShadow: true,
          boxShadowX: -4,
          boxShadowY: 4,
          boxShadowBlur: 18,
          boxShadowSpread: 1,
          boxShadowColor: 'rgba(0, 0, 0, 0.52)',
          fillStyle: 'solid',
          backgroundColor: 'rgba(0, 0, 0, 0.9)',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          backgroundImage: false,
          backgroundImageUrl: '',
          borderTopLeftRadius: 15,
          borderTopRightRadius: 15,
          borderBottomRightRadius: 15,
          borderBottomLeftRadius: 15,
          blur: false,
          blurSize: 10,
          skewX: -25,
          skewY: 0,
          rotate: 0,
          styles: {
            top: 180,
            left: 375,
            width: 790,
            height: 120,
            opacity: 1,
          },
        },
        {
          version: 'v1',
          type: 'rectangle',
          name: 'Green Box',
          locked: false,
          aspectLock: false,
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          border: true,
          borderWidth: 8,
          borderColor: 'rgb(255, 255, 255)',
          boxShadow: true,
          boxShadowX: -4,
          boxShadowY: 4,
          boxShadowBlur: 18,
          boxShadowSpread: 1,
          boxShadowColor: 'rgba(0, 0, 0, 0.52)',
          fillStyle: 'solid',
          backgroundColor: 'rgba(0, 44, 129, 0.9)',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          backgroundImage: false,
          backgroundImageUrl: '',
          borderTopLeftRadius: 15,
          borderTopRightRadius: 15,
          borderBottomRightRadius: 15,
          borderBottomLeftRadius: 15,
          blur: false,
          blurSize: 10,
          skewX: 0,
          skewY: 0,
          rotate: 0,
          styles: {
            top: 309,
            left: 349,
            width: 790,
            height: 525,
            opacity: 1,
          },
        },
        {
          version: 'v1',
          type: 'rectangle',
          name: 'BG',
          locked: false,
          aspectLock: false,
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          border: false,
          borderWidth: 2,
          borderColor: '#000000',
          boxShadow: false,
          boxShadowX: 1,
          boxShadowY: 2,
          boxShadowBlur: 4,
          boxShadowSpread: 0,
          boxShadowColor: '#000000',
          fillStyle: 'solid',
          backgroundColor: 'rgba(15, 132, 251, 0)',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          backgroundImage: true,
          backgroundImageUrl: `${TGB_ASSETS_URL}/backgrounds/baseball-field.jpg`,
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0,
          blur: false,
          blurSize: 10,
          skewX: 0,
          skewY: 0,
          rotate: 0,
          styles: {
            top: 0,
            left: 0,
            width: 1920,
            height: 1080,
            opacity: 1,
          },
        },
      ],
    };
  },
};
